export enum EMenuType {
  NAVIGATION = 'NAVIGATION',
  DETAILS = 'DETAILS',
  REGULATION = 'REGULATION'
}
